import { render, staticRenderFns } from "./COEndpointsList.vue?vue&type=template&id=1c958b9e"
import script from "./COEndpointsList.vue?vue&type=script&lang=js"
export * from "./COEndpointsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c958b9e')) {
      api.createRecord('1c958b9e', component.options)
    } else {
      api.reload('1c958b9e', component.options)
    }
    module.hot.accept("./COEndpointsList.vue?vue&type=template&id=1c958b9e", function () {
      api.rerender('1c958b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/CrossOrg/COEndpointsList.vue"
export default component.exports